import { render, staticRenderFns } from "./CerrarCaso.vue?vue&type=template&id=42268bce&scoped=true"
import script from "./CerrarCaso.vue?vue&type=script&lang=js"
export * from "./CerrarCaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42268bce",
  null
  
)

export default component.exports